import { Facebook, Instagram, Linkedin, Youtube, Twitter, AtSign } from "lucide-react";

/**
 * Shared platform icon component — used across all pages.
 * Renders the platform's branded icon/text.
 * @param {string} platform - facebook | instagram | linkedin | tiktok | google_business | youtube | twitter | threads
 * @param {number} size - icon size in px (default 18)
 * @param {string} className - additional CSS classes (overrides default color)
 */
const PlatformIcon = ({ platform, size = 18, className }) => {
  switch ((platform || "").toLowerCase()) {
    case "facebook":        return <Facebook size={size} className={className ?? "text-blue-600"} />;
    case "instagram":       return <Instagram size={size} className={className ?? "text-pink-500"} />;
    case "linkedin":        return <Linkedin size={size} className={className ?? "text-sky-700"} />;
    case "youtube":         return <Youtube size={size} className={className ?? "text-red-600"} />;
    case "twitter":         return <Twitter size={size} className={className ?? "text-stone-700"} />;
    case "tiktok":          return <span className={`font-bold text-xs ${className || "text-stone-900"}`}>TT</span>;
    case "google_business": return <span className={`font-bold text-xs ${className || "text-amber-600"}`}>G</span>;
    // Threads hat kein offizielles lucide-Icon — AtSign ist die gängigste semantische Approximation
    // für das Threads-"@"-Wortmarken-Element und passt zur konversationellen Natur der Plattform.
    case "threads":         return <AtSign size={size} className={className ?? "text-stone-900"} />;
    default:                return null;
  }
};

export default PlatformIcon;
